import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
 import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NzNotificationService } from 'ng-zorro-antd';
import { OrgInfo } from 'src/app/Models/orginfo';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-orginfo',
  templateUrl: './orginfo.component.html',
  styleUrls: ['./orginfo.component.css'],
  providers: [DatePipe]
})
export class OrginfoComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: OrgInfo;
    isSpinning = false
  logtext:string = "";
  isokfile:boolean


 date = new Date();
 date1 = this.datePipe.transform(this.date, 'yyyyMMdd')
fileDataIMAGE_URL:File=null
 folderName= "OrgInfoImages"
 editorConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: 'auto',
  minHeight: '0',
  maxHeight: 'auto',
  width: 'auto',
  minWidth: '0',
  translate: 'yes',
  enableToolbar: true,
  showToolbar: true,
  placeholder: 'Enter text here...',
  defaultParagraphSeparator: '',
  defaultFontName: '',
  defaultFontSize: '',
  fonts: [
    { class: 'arial', name: 'Arial' },
    { class: 'times-new-roman', name: 'Times New Roman' },
    { class: 'calibri', name: 'Calibri' },
    { class: 'comic-sans-ms', name: 'Comic Sans MS' }
  ],
  customClasses: [
    {
      name: 'quote',
      class: 'quote',
    },
    {
      name: 'redText',
      class: 'redText'
    },
    {
      name: 'titleText',
      class: 'titleText',
      tag: 'h1',
    },
  ],
  sanitize: true,
  toolbarPosition: 'top',
  toolbarHiddenButtons: [
    ['bold', 'italic'],
    ['fontSize']
  ]
};
  constructor(private api: ApiService, private message: NzNotificationService,private datePipe :DatePipe) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - OrgInfo form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.DESCRIPTION == undefined || this.data.DESCRIPTION=="") {
      this.message.error("Please Enter Description" , "");
      isOk = false
    }
    if(isOk)
    {

    this.isSpinning = true;
  
      if (this.data.ID) {

	 if (this.fileDataIMAGE_URL) {
 if (this.data.IMAGE_URL == "") {
  this.data.IMAGE_URL = this.genarateKeyIMAGE_URL();
}
   else {
 var str = this.data.IMAGE_URL.substring(this.data.IMAGE_URL.lastIndexOf('/') + 1).split('.')
    var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
  var url = str[0] + "." + fileExt;
   this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
   //this.data.IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
   this.data.IMAGE_URL = url;
   console.log(url)
 }
  }
 else { 
 this.data.IMAGE_URL = ""
  }

        this.api.updateOrgInfo(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.data.IMAGE_URL = null
              this.message.success("OrgInfo information updated Successfully...", "");

	this.logtext = 'Update & Close - OrgInfo form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - OrgInfo ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - OrgInfo form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - OrgInfo ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update orgInfo information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {
 if (this.fileDataIMAGE_URL) {
 this.data.IMAGE_URL = this.genarateKeyIMAGE_URL()
}
  else {
  this.data.IMAGE_URL = "";
 }
        this.api.createOrgInfo(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.data.IMAGE_URL = null
              this.message.success("OrgInfo information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - OrgInfo form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - OrgInfo ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new OrgInfo();
	this.logtext = 'Save & New - OrgInfo form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - OrgInfo ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add orgInfo information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - OrgInfo form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - OrgInfo ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}

 genarateKeyIMAGE_URL() {
 var number = Math.floor(100000 + Math.random() * 900000)  
var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
 var url = this.date1 + number + "." + fileExt
  this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
 // this.data.IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
 this.data.IMAGE_URL = url;
 console.log(url)
  return this.data.IMAGE_URL
} 
onFileSelectedIMAGE_URL(event) {
  {
    this.isokfile = true
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowed_types.toString().match(event.target.files[0].type)) {
      this.isokfile = false
      this.message.error("Only PNG/JPG/JPEG Images are allowed ", "");
    }

    if (this.isokfile) {
      this.fileDataIMAGE_URL = <File>event.target.files[0];
    }

  }


}
 clear() {
  this.fileDataIMAGE_URL = null
}
}